import React from 'react';
import Page, { PageHeader, PageTitle } from 'components/Page';
import AdsSearch from './components/AdsSearch';

export default function Search() {
  return (
    <Page>
      <PageHeader>
        <PageTitle>جستجو در لیست سفارشات</PageTitle>
      </PageHeader>

      <div>
        <AdsSearch />
        <br />
      </div>
    </Page>
  );
}
